import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsBreadcrumbComponent } from "./ds-breadcrumb.component";
import { RouterModule } from "@angular/router";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsBreadcrumbComponent],
  imports: [CommonModule, RouterModule, DsIconModule],
  exports: [DsBreadcrumbComponent],
})
export class DsBreadcrumbModule {}
